"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.getFocusedStyle = exports.getSelectedStyle = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _theme = require("../theme");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var OptionItem = (0, _theme.styled)('li')(function (_ref) {
  var theme = _ref.theme,
      itemIndex = _ref.itemIndex,
      selectedIndex = _ref.selectedIndex;
  return _objectSpread({
    color: theme.components.select.color
  }, getSelectedStyle({
    theme: theme,
    isSelected: itemIndex === selectedIndex
  }), {}, getFocusedStyle({
    theme: theme,
    itemIndex: itemIndex,
    selectedIndex: selectedIndex
  }), {
    boxSizing: 'border-box',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'space-between',
    margin: 0,
    minHeight: 48,
    padding: 16,
    '&:focus': {
      outline: 0
    }
  });
});

var getSelectedStyle = function getSelectedStyle(_ref2) {
  var theme = _ref2.theme,
      isSelected = _ref2.isSelected;
  var select = theme.components.select;
  return isSelected ? {
    alignItems: 'center',
    backgroundColor: select.selected.backgroundColor,
    color: select.selected.color
  } : {};
};

exports.getSelectedStyle = getSelectedStyle;

var getFocusedStyle = function getFocusedStyle(_ref3) {
  var _ref4;

  var theme = _ref3.theme,
      itemIndex = _ref3.itemIndex,
      selectedIndex = _ref3.selectedIndex;
  var select = theme.components.select;
  return itemIndex === selectedIndex ? (_ref4 = {}, (0, _defineProperty2.default)(_ref4, '&:first-of-type', {
    borderTopLeftRadius: select.dropdown.borderRadius,
    borderTopRightRadius: select.dropdown.borderRadius
  }), (0, _defineProperty2.default)(_ref4, '&:last-child', {
    borderBottomLeftRadius: select.dropdown.borderRadius,
    borderBottomRightRadius: select.dropdown.borderRadius
  }), (0, _defineProperty2.default)(_ref4, "backgroundColor", select.focus.backgroundColor), _ref4) : {};
};

exports.getFocusedStyle = getFocusedStyle;
var _default = OptionItem;
exports.default = _default;